import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import VanLife from './pages/VanLife';
import Contact from './pages/Contact';
import VanBooking from './pages/VanBooking';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/cookies';
import CGU from './pages/CGU';
import MentionsLegales from './pages/MentionsLeg';
import PolitiqueConfidentialite from './pages/PolitiqueConf';
import PolitiqueCookies from './pages/PolitiqueCookies';
import About from './pages/About';
import FAQ from './pages/FAQ';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/van-life" element={<VanLife />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reservation" element={<VanBooking />} />
          <Route path="/reserver" element={<VanBooking/>} />
          <Route path="/conditions-generales" element={<CGU />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cookies" element={<PolitiqueCookies />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </Layout>
    </Router>
  
  );
}

export default App;
